import { TOrbit } from '../../i18n/TModules';
import { Translate } from '../wizard/adapters/ruleAdapter';
import { AudienceProperty, AudienceState } from './audienceModel';

const TA = `${TOrbit}.configStudio.audience`;

/** The JSON half of the module's create body (`Audience/form/index.tsx` `_payload`). */
export interface AudienceFormValues {
  name: string;
  filters: Record<string, unknown>;
  auto_create_customers: boolean;
}

export interface AudienceWizardValues {
  values: AudienceFormValues;
  /** Drawn answers with no module key (backend ask); never sent as audience fields. */
  unsupported: Record<string, unknown>;
}

const complete = (property: AudienceProperty) =>
  property.key.trim() !== '' && property.value.trim() !== '';

export const buildAudienceValues = (state: AudienceState): AudienceWizardValues => {
  const criteria = state.properties.filter(complete).map(property => ({
    type: 'string',
    attribute: property.key.trim(),
    operator: property.operator,
    selected_values: property.value.trim()
  }));
  const locked = state.properties.filter(property => property.locked).map(property => property.key);
  const others = state.attributes.filter(attribute => attribute !== 'custom');
  return {
    values: {
      name: state.name.trim(),
      filters:
        criteria.length > 0 ? { custom_attributes: [{ type: 'custom_attributes', criteria }] } : {},
      auto_create_customers: false
    },
    unsupported: {
      ...(locked.length > 0 ? { locked_keys: locked } : {}),
      ...(others.length > 0 ? { attributes: others } : {})
    }
  };
};

// "A,,B" or a trailing comma leaves an empty item in an in / not in list.
const emptyItem = (property: AudienceProperty) =>
  (property.operator === 'in' || property.operator === 'not_in') &&
  property.value.split(',').some(item => item.trim() === '');

/** What still blocks "Create audience". */
export const audienceErrors = (state: AudienceState, t: Translate): string[] => {
  const errors: string[] = [];
  if (state.name.trim() === '') {
    errors.push(t(`${TA}.nameRequired`));
  }
  const started = state.properties.filter(
    property => property.key.trim() !== '' || property.value.trim() !== ''
  );
  if (started.length === 0 || started.some(property => !complete(property))) {
    errors.push(t(`${TA}.filterRequired`));
  } else if (started.some(emptyItem)) {
    errors.push(t(`${TA}.commaNotAllowed`));
  }
  return errors;
};
